import { render, staticRenderFns } from "./FeatureShansuan.vue?vue&type=template&id=3355eb5e&scoped=true&"
import script from "./FeatureShansuan.vue?vue&type=script&lang=ts&"
export * from "./FeatureShansuan.vue?vue&type=script&lang=ts&"
import style0 from "./FeatureShansuan.vue?vue&type=style&index=0&id=3355eb5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3355eb5e",
  null
  
)

component.options.__file = "FeatureShansuan.vue"
export default component.exports